import React from 'react';
import cx from 'classnames';


const ButtonSeparator = ({className, ...props}) => <i className={cx('btn', 'btn--separator', className)} {...props} />

export default ButtonSeparator;
